import { Typography } from 'shared/components';
import { usePersonalLoan, usePersonalLoanRouteFsm } from 'shared/hooks';
import CreditLocked from './CreditLocked';
import FrozenPinForm from './FrozenPin';

const FrozenLockContainer = () => {
  const { personalLoan, uuid, saveFrozenPin, error: personalLoanError } = usePersonalLoan();
  const runRouter = usePersonalLoanRouteFsm();

  let reason = 'frozen';
  if (personalLoan.status?.softCreditLocked) reason = 'locked';
  if (personalLoan.status?.softCreditFrozen) reason = 'frozen';

  // if (!reason) return null;

  const serverError = personalLoanError || '';

  const handleSubmit = async (data) => {
    await saveFrozenPin({
      plUuid: uuid,
      pin: data.pin,
    });

    runRouter();
  };

  return (
    <>
      <Typography.PageHeader>Thank you for starting your application today.</Typography.PageHeader>
      <h3>We would like to consider you for a personal loan. However, our records show your credit is {reason}.</h3>
      {reason === 'locked' && <CreditLocked />}
      {reason === 'frozen' && <FrozenPinForm handleSubmit={handleSubmit} serverError={serverError} />}
    </>
  );
};

export default FrozenLockContainer;
